import { Component, ErrorInfo, ReactNode } from 'react';
import {
  isChunkLoadError,
  reloadOnceForStaleChunk,
} from '../utilities/lazyWithRetry';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

/**
 * Catches chunk-load failures that bubble past Suspense and reloads once.
 */
class ChunkErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State | null {
    if (isChunkLoadError(error)) {
      return { hasError: true };
    }
    return null;
  }

  componentDidCatch(error: Error, _info: ErrorInfo): void {
    if (isChunkLoadError(error)) {
      reloadOnceForStaleChunk();
    }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
